import clsx from "clsx"

const RichText = ({
  content,
  className,
}: {
  content: string
  className?: string
}) => (
  <div
    className={clsx(
      "prose prose-invert prose:first:mt-0 leading-relaxed wrap-break-word text-gray-500",

      "prose-headings:font-bold prose-headings:leading-snug prose-headings:text-white prose-headings:first:mt-0 prose-headings:mt-[3em]",

      "prose-h1:text-2xl",
      "prose-h2:text-base",
      "prose-h3:text-base",

      "prose-ul:list-disc prose-ol:list-decimal",

      "prose-a:hover:no-underline prose-a:text-gray-400 prose-a:hover:text-white",

      className
    )}
    dangerouslySetInnerHTML={{ __html: content }}
  />
)

export default RichText
